import axios from "../httpClient";

function getBotConfiguration() {
  return axios.get(`/bot-configuration`);
}

function editBotConfiguration(body) {
  return axios.patch(`/bot-configuration`, body);
}

function updateDs82StandardOnlineRenewal(enabled) {
  return axios.patch(`/bot-configuration/ds82/standard-online-renewal`, {
    enabled,
  });
}

export default {
  getBotConfiguration,
  editBotConfiguration,
  updateDs82StandardOnlineRenewal,
};
